module.exports = __webpack_public_path__ + "img/img60_4.f20b8645.png";